import { Page, PageLink } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { useGetOrganizationSettingsQuery } from "~/pages/Brand/OrganizationSettings/ProductPages/hooks.ts"
import { useAuth } from "~/store/auth-context.tsx"

export const ProductsListWrapper = () => {
  const { t } = useTranslation("products")

  const { user, isAdmin } = useAuth()
  const { data: org } = useGetOrganizationSettingsQuery(user?.organization?.id)

  const pages = useMemo<PageLink[]>(() => {
    const tabs = [
      {
        label: t("lists.tabs.general"),
        link: "general",
      },
      {
        label: t("lists.tabs.traceability"),
        link: "traceability",
      },
      {
        label: t("lists.tabs.certificates"),
        link: "certificates",
        wip: org?.settings?.certificatesPlan !== "EXPERT" && !isAdmin,
      },
      {
        label: t("lists.tabs.customFields"),
        link: "custom-fields",
      },
    ]
    return tabs
  }, [t, org, isAdmin])

  return <Page title={t("lists.title")} pages={pages} />
}
